import { memo } from 'react';
import { Box, Text } from '@betty/moonlight';
import Games from '../../Games/Games';
import usePromotedContent from '../../../hooks/usePromotedContent';

function NoResults() {
  const { gameIds } = usePromotedContent();

  return (
    <Box paddingTop="space-400">
      <Text
        variant="body-m"
        color="darkSurfacePrimary"
        paddingBottom="space-400"
        locKey={
          gameIds.length
            ? 'noResultsWithPromotedGames'
            : 'noResultsWithoutPromotedGames'
        }
        locNS="games"
      />
      {gameIds.length ? (
        <Games ids={gameIds} imageType="square" paddingLeft="-space-100" />
      ) : null}
    </Box>
  );
}

export default memo(NoResults);
